import {
  convertToTableData,
  getMonthIntervals,
} from "@taabl/common-lib/transformers/ExpenseReport";
import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Constants } from "../libs/Constants";
import {
  exportModificationsToFile,
  generateJsonModification,
} from "../libs/ExportModifications";
import { convertDate, formatCurrency, getDetailsFromKey } from "../libs/utils";
const moment = require("moment");
const columns = [
  {
    dataField: "type",
    sort: true,
    text: "S",
    formatter: (cell) => {
      return <span className={`tbl-${cell}`}>{cell}</span>;
    },
    footer: "Totals",
  },
  {
    dataField: "employeeNumber",
    text: "Employee Number",
    sort: true,
    classes: "col-empid",
    footer: (columnData) => {
      let unique = columnData.filter((item, i, ar) => ar.indexOf(item) === i);
      return `${unique.length} Users`;
    },
  },
  {
    dataField: "employeeName",
    sort: true,
    text: "Employee Name",
    headerStyle: () => {
      return { width: "150px" };
    },
    footer: "",
    hidden: false,
  },
  {
    dataField: "costCenter",
    sort: true,
    text: "Cost Center",
    headerStyle: () => {
      return { width: "200px" };
    },
    footer: "",
    hidden: false,
  },
  {
    dataField: "subsidiary",
    headerStyle: () => {
      return { width: "200px" };
    },
    sort: true,
    text: "Subsidiary",
    footer: "",
    hidden: false,
  },
  {
    dataField: "newContribution",
    sort: true,
    text: "New Contribution $",
    headerStyle: () => {
      return { width: "150px" };
    },
    formatter: (cell) => {
      return formatCurrency(cell);
    },
    footer: "",
  },
  {
    dataField: "oldContribution",
    sort: true,
    text: "Old Contribution $",
    headerStyle: () => {
      return { width: "150px" };
    },
    formatter: (cell) => {
      return formatCurrency(cell);
    },
    footer: "",
  },
  {
    dataField: "increase",
    sort: true,
    headerStyle: () => {
      return { width: "150px" };
    },
    text: "Increase",
    formatter: (cell) => {
      return formatCurrency(cell);
    },
    footer: "",
  },
  {
    dataField: "offeringPeriod",
    sort: true,
    text: "Offering Period",
    footer: "",
  },
  {
    dataField: "offeringPrice",
    sort: true,
    text: "Offering Period Lookback Price",
    formatter: (cell) => {
      return formatCurrency(cell);
    },
    footer: "",
  },
];
export default class Modifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableColumns: columns,
      tableData: [],
      totals: {
        modificationCharge: 0,
        avgCostPerDay: 0,
      },
    };
    this.loadTabledata = this.loadTabledata.bind(this);
    this.loadtableColumns = this.loadtableColumns.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.offer && Object.keys(nextProps.offer).length > 0) {
      this.loadtableColumns();
      this.loadTabledata();
      if (this.props.exportToExcel !== nextProps.exportToExcel) {
        this.exportToFile();
      }
    }
  }

  exportToFile() {
    let totalPeriods = this.props.totalTranche;
    let start = this.props.offer.offerStartdate;
    let end = this.props.offer.offerEnddate;
    if (this.props.selectedPeriod) {
      totalPeriods = 1;
      start = this.props.selectedPeriod.periodStartdate;
      end = this.props.selectedPeriod.periodEnddate;
    }
    exportModificationsToFile(
      this.state.tableData,
      start,
      end,
      this.props.trancheArray,
      this.props.activeCompany,
      totalPeriods
    );
  }
  componentDidMount() {
    if (this.props.modifications && this.props.modifications.length > 0) {
      this.loadtableColumns();
      this.loadTabledata();
    }
  }
  loadtableColumns() {
    let sDate = null;
    let eDate = null;
    if (
      this.props.selectedPeriod &&
      this.props.selectedPeriod.type === Constants.PERIOD_DISPLAY_TYPES.PURCHASE
    ) {
      sDate = this.props.selectedPeriod.period.periodStartdate;
      eDate = this.props.selectedPeriod.period.periodEnddate;
    } else {
      sDate = this.props.offer.offerStartdate;
      eDate = this.props.offer.offerEnddate;
    }

    let tColumns = [
      ...columns,
      {
        dataField: "modificationDate",
        sort: true,
        text: "Modification Date",
        headerStyle: () => {
          return { width: "150px" };
        },
        formatter: (cell) => {
          return convertDate(
            cell,
            Constants.DATEFORMAT.MMDDYYYY,
            false,
            this.props.activeCompany.timezone
          );
        },
        footer: "",
      },
      {
        dataField: "offerEndDate",
        sort: true,
        text: "Offering Period End Date",
        headerStyle: () => {
          return { width: "150px" };
        },
        formatter: (cell) => {
          return convertDate(
            cell,
            Constants.DATEFORMAT.MMDDYYYY,
            false,
            this.props.activeCompany.timezone
          );
        },
        footer: "",
      },
    ];
    if (
      this.props.selectedPeriod &&
      this.props.selectedPeriod.type ===
        Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION
    ) {
      for (let i of this.props.trancheArray) {
        tColumns.push({
          dataField: `shares${i + 1}`,
          sort: true,
          hidden: false,
          text: `P${i + 1} Shares`,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
        });
      }
      for (let i of this.props.trancheArray) {
        tColumns.push({
          dataField: `value${i + 1}`,
          sort: true,
          hidden: false,
          text: `P${i + 1} Value`,
          formatter: (cell) => {
            return formatCurrency(cell);
          },
          footer: "",
        });
      }
    } else {
      tColumns.push({
        dataField: `shares`,
        sort: true,
        hidden: false,
        text: `Shares`,
        footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0),
      });
      tColumns.push({
        dataField: `value`,
        sort: true,
        hidden: false,
        text: `Value`,
        formatter: (cell) => {
          return formatCurrency(cell);
        },
        footer: "",
      });
    }
    tColumns.push({
      dataField: `totalValue`,
      sort: true,
      text: `Total Modification Charge`,
      headerStyle: () => {
        return { width: "150px" };
      },
      formatter: (cell) => {
        return formatCurrency(cell);
      },
      footer: (columnData) =>
        formatCurrency(columnData.reduce((acc, item) => acc + item, 0)),
    });

    tColumns.push({
      dataField: `remainingDays`,
      sort: true,
      text: `Remaining Service Period Days`,
      footer: "",
    });

    tColumns.push({
      dataField: `expPerDay`,
      sort: true,
      text: `Expense per Day`,
      formatter: (cell) => {
        return formatCurrency(cell);
      },
      footer: "",
    });
    let monthsArray = getMonthIntervals(
      sDate,
      eDate,
      this.props.activeCompany.timezone
    );
    for (let month of monthsArray) {
      tColumns.push({
        dataField: convertDate(
          month.lastDayofMonth,
          Constants.DATEFORMAT.MMDDYYYY,
          false,
          this.props.activeCompany?.timezone
        ),
        sort: true,
        headerStyle: () => {
          return { width: "150px" };
        },
        formatter: (cell) => {
          if (!cell) {
            return "-";
          }
          return formatCurrency(cell);
        },
        text: convertDate(
          month.lastDayofMonth,
          Constants.DATEFORMAT.MMDDYYYY,
          false,
          this.props.activeCompany?.timezone
        ),
        hidden: false,
        footer: (columnData) =>
          formatCurrency(
            columnData.reduce((acc, item) => acc + (item || 0), 0)
          ),
      });
    }
    let mutableColList = [
      "subsidiary",
      "costCenter",
      "p1",
      "p2",
      "p3",
      "p4",
      "expenses",
    ];

    let field = null;
    // let selectedColumns = Object.assign(this.props.selectedColumns);
    if (this.props.selectedColumns) {
      if (!this.props.selectedColumns.includes("showAll")) {
        for (let col of mutableColList) {
          if (this.props.selectedColumns.indexOf(col) < 0) {
            tColumns = tColumns.filter((column) => {
              field = column.text.toLowerCase();
              if (col === "subsidiary" || col === "costCenter")
                return column.dataField !== col;
              if (col.startsWith("p")) {
                if (!field.startsWith(col)) return column;
              }
              if (col === "expenses") {
                if (!field.includes("/")) {
                  return column;
                }
              }
            });
          }
        }
      }
    }
    this.setState({
      tableColumns: tColumns,
    });
  }

  loadTabledata() {
    if (!this.props.modifications || this.props.modifications.length === 0) {
      return;
    }
    let tableRows = [];
    // Let's first group modifications by user
    let modificationsByUser = this.groupModificationByUser(
      this.props.modifications
    );

    let typeModifications = {};
    for (let key in modificationsByUser) {
      // We only need to get the last modifications type of each user
      let lastModificationsType = modificationsByUser[key][0].type;
      // If last modifications was increase or decrease then we need to include that in report
      if (
        lastModificationsType === Constants.CONTRIBUTION_STATUS.INCREASE ||
        lastModificationsType === Constants.CONTRIBUTION_STATUS.DECREASE
      ) {
        lastModificationsType = Constants.CONTRIBUTION_STATUS.NEW;
      }

      // Merge all filtered modifications
      if (!(lastModificationsType in typeModifications)) {
        typeModifications[lastModificationsType] = [];
      }
      modificationsByUser[key].map((current) => {
        typeModifications[lastModificationsType].push(current);
      });
    }
    if (
      this.props.types.includes("showAll") ||
      this.props.types.includes("current")
    ) {
      if (Constants.CONTRIBUTION_STATUS.NEW in typeModifications) {
        typeModifications[Constants.CONTRIBUTION_STATUS.NEW].sort((a, b) =>
          b.type.localeCompare(a.type)
        );
        let generatedRows = generateJsonModification(
          typeModifications[Constants.CONTRIBUTION_STATUS.NEW],
          Constants.CONTRIBUTION_STATUS.NEW,
          this.props.totalTranche,
          this.props.offer,
          this.props.selectedPeriod,
          this.props.activeCompany
        );
        if (generatedRows) {
          tableRows.push(...generatedRows);
        }
      }
    }
    if (
      this.props.types.includes("showAll") ||
      this.props.types.includes("withdrawls")
    ) {
      if (Constants.CONTRIBUTION_STATUS.WITHDRAW in typeModifications) {
        let generatedRows = generateJsonModification(
          typeModifications[Constants.CONTRIBUTION_STATUS.WITHDRAW],
          Constants.CONTRIBUTION_STATUS.WITHDRAW,
          this.props.totalTranche,
          this.props.offer,
          this.props.selectedPeriod,
          this.props.activeCompany
        );
        if (generatedRows) {
          tableRows.push(...generatedRows);
        }
      }
    }
    if (
      this.props.types.includes("showAll") ||
      this.props.types.includes("terminations")
    ) {
      if (Constants.CONTRIBUTION_STATUS.TERMINATE in typeModifications) {
        let generatedRows = generateJsonModification(
          typeModifications[Constants.CONTRIBUTION_STATUS.TERMINATE],
          Constants.CONTRIBUTION_STATUS.TERMINATE,
          this.props.totalTranche,
          this.props.offer,
          this.props.selectedPeriod,
          this.props.activeCompany
        );
        if (generatedRows) {
          tableRows.push(...generatedRows);
        }
      }
    }
    //search for string after converting in to lowercase
    if (this.props.searchItem) {
      let searchFor = this.props.searchItem.toLowerCase();

      tableRows = tableRows.filter((item) => {
        let cc = item.costCenter.toLowerCase();
        let sub = item.subsidiary.toLowerCase();
        let name = item.employeeName.toLowerCase();
        if (
          cc.includes(searchFor) ||
          sub.includes(searchFor) ||
          name.includes(searchFor)
        )
          return item;
      });
    }
    let totals = this.generateTotalRow(tableRows);
    this.setState({
      tableData: tableRows,
      totals: totals,
    });
  }
  groupModificationByUser(modifications) {
    // Let's first group contribution by user
    let modificationsByUser = {};

    for (let current of modifications) {
      let user = getDetailsFromKey(current.object_id);
      if (user in modificationsByUser) {
        modificationsByUser[user].push(current);
      } else {
        modificationsByUser[user] = [current];
      }
    }
    // Sort them by created at
    for (let key in modificationsByUser) {
      modificationsByUser[key] = modificationsByUser[key].sort(
        (a, b) => b.modificationDate - a.modificationDate
      );
    }
    return modificationsByUser;
  }
  generateTotalRow(tableRows) {
    let totalCostPerDay = 0;
    let rowCount = 0;
    let totalModification = 0;
    for (let row of tableRows) {
      totalModification += row.totalValue;
      totalCostPerDay += row.expPerDay;
      rowCount++;
    }
    return {
      modificationCharge: totalModification,
      avgCostPerDay: totalCostPerDay / rowCount,
    };
  }
  renderTotals() {
    return (
      <div className="d-flex justify-content-end flex-column flex-sm-row pt-4">
        <div className="d-flex flex-column flex-sm-row pt-4 bottom-cal">
          <div className="boot-txt p-2">
            <h4>Total Modification Charge:</h4>
            <p>{formatCurrency(this.state.totals.modificationCharge)}</p>
          </div>
          <div className="boot-txt p-2">
            <h4>Average Cost/Day:</h4>
            <p>{formatCurrency(this.state.totals.avgCostPerDay)}</p>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div className="me-3 mt-5">
        <BootstrapTable
          id="modifications"
          bootstrap4={true}
          wrapperClasses="table-fixed-height"
          classes="table-taabl"
          keyField="id"
          bordered={false}
          data={convertToTableData(this.state.tableData)}
          columns={this.state.tableColumns}
        />
        {this.state.totals && this.renderTotals()}
      </div>
    );
  }
}
